import {
  StyleCard,
  StyleCardFooter,
  StyleCardHeader,
  StyleLeftCardHeader,
  StyleRightCardHeader,
} from './style'
import Column from '@components/column'
import Row from '@components/row'
import Skeleton from '@components/skeleton'
const AppointmentRequestCardLoader = ({ styleCard }: any) => {
  return (
    <StyleCard styleCard={styleCard}>
      <StyleCardHeader>
        <StyleLeftCardHeader>
          <Skeleton width={50} height={50} radius={25} />
          <Column rowGap={10}>
            <Skeleton width={120} height={10} radius={4} />
            <Row colGap={10}>
              <Skeleton width={45} height={25} radius={4} />
              <Skeleton width={45} height={25} radius={4} />
              <Skeleton width={45} height={25} radius={4} />
            </Row>
          </Column>
        </StyleLeftCardHeader>
        <StyleRightCardHeader>
          <Skeleton width={45} height={25} radius={4} />
        </StyleRightCardHeader>
      </StyleCardHeader>
      <Row
        justifyContent="space-between"
        colGap={10}
        styleRow="margin-top:20px;"
      >
        <Skeleton width={120} height={45} radius={4} />
        <Skeleton width={80} height={45} radius={4} />
      </Row>
      <StyleCardFooter>
        <Skeleton width={120} height={45} radius={8} />
        <Skeleton width={120} height={45} radius={8} />
      </StyleCardFooter>
    </StyleCard>
  )
}

export default AppointmentRequestCardLoader
